import Vue from 'vue';
import 'chartist/dist/chartist.min.css';
import VueChartist from 'vue-chartist';

Vue.use(VueChartist);
